module.exports = __webpack_public_path__ + "img/icon-download-white.8dcf1e89.svg";